import React, { useRef, useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import LoadingOverlay from "react-loading-overlay";

import axios from "../../../service/axios";
import * as Constants from "../../../constants/Constants";
import "./ReportsModal.css";
import ErrorContainer from "../../Common/Errors/ErrorContainer";
import * as RolePermissionConstants from "../../../constants/RolePermissionConstants";
import { getUserRolePermission } from "../../../utils/rolePermissionAccess";

import {
  httpGetEntireVendorsForReporting,
  httpGetDetailedStatusReport,
  httpGetEntireBigTicketVendorsReporting,
  httpGetEntireVendorsOnboardingStatusReport,
  httpGetConfigByType
} from "../../../service/httpClient";

const ReportsModal = ({ toggleModal, dashboardYear }) => {
  const statusRef = useRef(null);
  const [yearoptions, setYearoptions] = useState([]);
  const [reportState, setReportState] = useState({
    selection: "",
    onboardingReport: false,
    detailedReport: false,
    detailedReportBigTicket: false,
    onboardingReportBigTicket: false,
    isLoading: false,
    updateStatus: false,
    errorStatus: false,
    successMsg: "",
    errorMsg: "",
    onboardingStatusReport: [],
    detailedStatusReport: [],
    detailedStatusReportBigTicket: [],
    onboardingStatusReportBigTicket: [],
  });
  const onChange = (e) => {
    const { name = "", checked } = (e && e.target) || {};
    const elementName =
      name === "onboardingReport"
        ? [
            "detailedReport",
            "detailedReportBigTicket",
            "onboardingReportBigTicket",
          ]
        : name === "detailedReport"
        ? [
            "onboardingReport",
            "detailedReportBigTicket",
            "onboardingReportBigTicket",
          ]
        : name === "onboardingReportBigTicket"
        ? ["onboardingReport", "detailedReport", "detailedReportBigTicket"]
        : ["onboardingReport", "detailedReport", "onboardingReportBigTicket"];

    elementName.map(
      (elName) => (document.getElementById(elName).checked = false)
    );
    setReportState((state) => ({
      ...state,
      [name]: checked,
      selection: (checked && name) || "",
      [elementName[0]]: false,
      [elementName[1]]: false,
      [elementName[2]]: false,
      updateStatus: false,
      errorStatus: false,
      successMsg: "",
      errorMsg: "",
    }));
  };
  
  const currentyear = new Date().getFullYear();

  useEffect(() => {
    httpGetConfigByType('startYear').then((response) => {
      console.log("Report start year", response.data[0].value);
      let reportStartYear = response.data[0].value;
      const years = [];
      const reportYearOptionsCount = currentyear - reportStartYear;
      years.push(currentyear);
      for (var num = 1; num <= reportYearOptionsCount; num++) {
        years.push(currentyear - num);
      }
      setYearoptions(years);
    }).catch((error) => {
      console.log(error)
    });
  }, []);  

  const getStatusReport = () => {
    setReportState((state) => ({ ...state, isLoading: true }));

    if (reportState && reportState.selection === "onboardingReport") {
      httpGetEntireVendorsForReporting(selectedYear)
        .then((res) => {
          const { data = [], status } = res || {};

          if (data && data.length > 0 && status === 200) {
            setReportState((state) => {
              return {
                ...state,
                onboardingStatusReport: data.map((item) => {
                  return {
                    ...item,
                    mbeWbeStatus:
                      item.mbeWbeStatus === null
                        ? ""
                        : item.mbeWbeStatus
                        ? "Yes"
                        : "No",
                  };
                }),
                isLoading: false,
                updateStatus: true,
                errorStatus: false,
                successMsg: `${Constants.ONBOARDING_STATUS_REPORT_SMALL_TICKET_VDF} successfully downloaded`,
              };
            });
            statusRef.current.link.click();
          }
        })
        .catch((error) => {
          setReportState((state) => ({
            ...state,
            onboardingStatusReport: [],
            isLoading: false,
            errorStatus: true,
            updateStatus: false,
            errorMsg: `Problem in downloading ${Constants.ONBOARDING_STATUS_REPORT_SMALL_TICKET_VDF}, try after sometime!`,
          }));
          console.log(error);
        });
    } else if (reportState && reportState.selection === "detailedReport") {
      httpGetDetailedStatusReport()
        .then((res) => {
          const { data = [], status } = res || {};

          if (data && data.length > 0 && status === 200) {
            setReportState((state) => {
              return {
                ...state,
                detailedStatusReport: data.map((item) => {
                  return {
                    ...item,
                    mbeWbeStatus:
                      item.mbeWbeStatus === null
                        ? ""
                        : item.mbeWbeStatus
                        ? "Yes"
                        : "No",
                  };
                }),
                isLoading: false,
                updateStatus: true,
                errorStatus: false,
                successMsg: `${Constants.DETAILED_STATUS_REPORT_SMALL_TICKET_VDF} successfully downloaded`,
              };
            });
            statusRef.current.link.click();
          } else {
            setReportState((state) => ({
              ...state,
              detailedStatusReport: [],
              isLoading: false,
              errorStatus: true,
              updateStatus: false,
              errorMsg: `Problem in downloading ${Constants.DETAILED_STATUS_REPORT_SMALL_TICKET_VDF}, try after sometime!`,
            }));
          }
        })
        .catch((error) => {
          console.log("error", error);
          setReportState((state) => ({
            ...state,
            detailedStatusReport: [],
            isLoading: false,
            errorStatus: true,
            updateStatus: false,
            errorMsg: `Problem in downloading ${Constants.DETAILED_STATUS_REPORT_SMALL_TICKET_VDF}, try after sometime!`,
          }));
        });
    } else if (
      reportState &&
      reportState.selection === "onboardingReportBigTicket"
    ) {
      httpGetEntireVendorsOnboardingStatusReport(selectedYear)
        .then((res) => {
          const { data = [], status } = res || {};

          if (data && data.length > 0 && status === 200) {
            setReportState((state) => {
              return {
                ...state,
                onboardingStatusReportBigTicket: data.map((item) => {
                  return {
                    ...item,
                    mbeWbeStatus:
                      item.mbeWbeStatus === null
                        ? ""
                        : item.mbeWbeStatus
                        ? "Yes"
                        : "No",
                  };
                }),
                isLoading: false,
                updateStatus: true,
                errorStatus: false,
                successMsg: `${Constants.ONBOARDING_STATUS_REPORT_BIG_TICKET_VDF} successfully downloaded`,
              };
            });
            statusRef.current.link.click();
          }
        })
        .catch((error) => {
          setReportState((state) => ({
            ...state,
            onboardingStatusReportBigTicket: [],
            isLoading: false,
            errorStatus: true,
            updateStatus: false,
            errorMsg: `Problem in downloading ${Constants.ONBOARDING_STATUS_REPORT_BIG_TICKET_VDF}, try after sometime!`,
          }));
          console.log(error);
        });
    } else if (
      reportState &&
      reportState.selection === "detailedReportBigTicket"
    ) {
      httpGetEntireBigTicketVendorsReporting(selectedYear)
        .then((res) => {
          const { data = [], status } = res || {};

          if (data && data.length > 0 && status === 200) {
            setReportState((state) => {
              return {
                ...state,
                detailedStatusReportBigTicket: data.map((item) => {
                  return {
                    ...item,
                    mbeWbeStatus:
                      item.mbeWbeStatus === null
                        ? ""
                        : item.mbeWbeStatus
                        ? "Yes"
                        : "No",
                  };
                }),
                isLoading: false,
                updateStatus: true,
                errorStatus: false,
                successMsg: `${Constants.DETAILED_STATUS_REPORT_BIG_TICKET} successfully downloaded`,
              };
            });
            statusRef.current.link.click();
          }
        })
        .catch((error) => {
          setReportState((state) => ({
            ...state,
            detailedStatusReportBigTicket: [],
            isLoading: false,
            errorStatus: true,
            updateStatus: false,
            errorMsg: `Problem in downloading ${Constants.DETAILED_STATUS_REPORT_BIG_TICKET}, try after sometime!`,
          }));
          console.log("error", error);
        });
    }
  };

  const handleClose = () => {
    setReportState({
      selection: "",
      onboardingReport: false,
      detailedReport: false,
      detailedReportBigTicket: false,
      onboardingReportBigTicket: false,
      isLoading: false,
      updateStatus: false,
      errorStatus: false,
      successMsg: "",
      errorMsg: "",
      onboardingStatusReport: [],
      detailedStatusReport: [],
      detailedStatusReportBigTicket: [],
      onboardingStatusReportBigTicket: [],
    });

    toggleModal("reportExport");
  };

  const getReportDate = () => {
    let reportDate = new Date();
    const dd = String(reportDate.getDate()).padStart(2, "0");
    const mm = String(reportDate.getMonth() + 1).padStart(2, "0");
    const yyyy = reportDate.getFullYear();
    const twoDigitYear = yyyy.toString().slice(-2);

    reportDate = mm + "-" + dd + "-" + twoDigitYear;

    return reportDate;
  };

  

  const [selectedYear, setSelectedYear] = useState(currentyear);

  return (
    <>
      <Modal
        className="exports-modal"
        show={true}
        onHide={handleClose}
        backdrop="static"
      >
        <LoadingOverlay active={reportState.isLoading} spinner>
          <Modal.Header closeButton>
            <Modal.Title>Export</Modal.Title>
          </Modal.Header>
          <div className="report-selection">
            <ErrorContainer
              errorMsg={reportState.errorMsg}
              updateStatus={reportState.updateStatus}
              successMsg={reportState.successMsg}
              errorStatus={reportState.errorStatus}
              errorStyle="errorMessage"
              successStyle="successMessage"
            />
            <select
              id="year"
              name="year"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="report_yearSelect"
            >
              {yearoptions.map((yearvalue, key) => {
                return (
                  <option key={key} value={yearvalue}>
                    {yearvalue}
                  </option>
                );
              })}
            </select>
            <div style={{ borderStyle: "groove", height: "180px" }}>
              <div className="selection-item">
                <input
                  type="checkbox"
                  name="onboardingReport"
                  id="onboardingReport"
                  onChange={(e) => onChange(e)}
                  value={reportState.onboardingReport}
                />
                <label htmlFor="onboardingReport">
                  {Constants.ONBOARDING_STATUS_REPORT_SMALL_TICKET_VDF}
                </label>
              </div>
              <div className="selection-item">
                <input
                  type="checkbox"
                  name="detailedReport"
                  id="detailedReport"
                  onChange={(e) => onChange(e)}
                  value={reportState.detailedReport}
                />
                <label htmlFor="detailedReport">
                  {Constants.DETAILED_STATUS_REPORT_SMALL_TICKET_VDF}
                </label>
              </div>
              <div className="selection-item">
                <input
                  type="checkbox"
                  name="onboardingReportBigTicket"
                  id="onboardingReportBigTicket"
                  onChange={(e) => onChange(e)}
                  value={reportState.onboardingReportBigTicket}
                />
                <label htmlFor="onboardingReportBigTicket">
                  {Constants.ONBOARDING_STATUS_REPORT_BIG_TICKET_VDF}
                </label>
              </div>
              <div className="selection-item">
                <input
                  type="checkbox"
                  name="detailedReportBigTicket"
                  id="detailedReportBigTicket"
                  onChange={(e) => onChange(e)}
                  value={reportState.detailedReportBigTicket}
                />
                <label htmlFor="detailedReportBigTicket">
                  {Constants.DETAILED_STATUS_REPORT_BIG_TICKET}
                </label>
              </div>
            </div>
          </div>
          <Modal.Footer>
            <Button
              disabled={
                !(
                  getUserRolePermission(
                    RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_REPORTS,
                    RolePermissionConstants.VMP_CANCEL
                  ) === RolePermissionConstants.EDIT
                )
              }
              className="button-later-md"
              onClick={() => handleClose()}
            >
              CANCEL
            </Button>
            <Button
              disabled={
                (reportState && reportState.selection === "") ||
                !(
                  getUserRolePermission(
                    RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_REPORTS,
                    RolePermissionConstants.VMP_EXPORT
                  ) === RolePermissionConstants.EDIT
                )
              }
              className="button-primary-md"
              onClick={() => getStatusReport()}
            >
              EXPORT
            </Button>

            <CSVLink
              data={
                reportState.onboardingReport
                  ? reportState.onboardingStatusReport
                  : reportState.detailedReport
                  ? reportState.detailedStatusReport
                  : reportState.onboardingReportBigTicket
                  ? reportState.onboardingStatusReportBigTicket
                  : reportState.detailedReportBigTicket
                  ? reportState.detailedStatusReportBigTicket
                  : []
              }
              headers={
                reportState.onboardingReport
                  ? Constants.ONBOARDINGSTATUSSMALLTICKETVDFREPORTHEADERS
                  : reportState.detailedReport
                  ? Constants.DETAILEDSTATUSREPORTHEADERS
                  : reportState.detailedReportBigTicket
                  ? Constants.DETAILEDSTATUSREPORTBIGTICKETHEADERS
                  : reportState.onboardingReportBigTicket
                  ? Constants.ONBOARDINGSTATUSSMALLTICKETVDFREPORTHEADERS
                  : []
              }
              filename={
                reportState.onboardingReport
                  ? `${
                      Constants.ONBOARDING_STATUS_REPORT_SMALL_TICKET_VDF
                    } ${getReportDate()}.csv`
                  : reportState.detailedReport
                  ? `${
                      Constants.DETAILED_STATUS_REPORT_SMALL_TICKET_VDF
                    } ${getReportDate()}.csv`
                  : reportState.onboardingReportBigTicket
                  ? `${
                      Constants.ONBOARDING_STATUS_REPORT_BIG_TICKET_VDF
                    } ${getReportDate()}.csv`
                  : reportState.detailedReportBigTicket
                  ? `${
                      Constants.DETAILED_STATUS_REPORT_BIG_TICKET
                    } ${getReportDate()}.csv`
                  : ""
              }
              style={{ textDecoration: "none" }}
              className="hidden"
              ref={statusRef}
              target="_blank"
            />
          </Modal.Footer>
        </LoadingOverlay>
      </Modal>
    </>
  );
};

export default ReportsModal;
